import * as React from 'react';

/**
 * @deprecated this class is completely empty, just use `React.Component` or `React.PureComponent` instead.
 */
export class DynamicThemeComponent<P, S> extends React.Component<P, S> { }
